export * from "./tab-group";
export { TabGroup as default } from "./tab-group";
